"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavCtaCallout = void 0;

var _react = _interopRequireDefault(require("react"));

var _gatsbyPluginImage = require("gatsby-plugin-image");

var _reactPortableText = _interopRequireDefault(require("react-portable-text"));

var _gatsby = require("gatsby");

var _hooks = require("material-ui-popup-state/hooks");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _core.makeStyles)(theme => ({
  card: {
    border: '1px solid #E5EAF4',
    boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.05)',
    borderRadius: '8px',
    '&:hover': {
      transition: 'all 0.25s',
      cursor: 'pointer',
      '& $arrow': {
        transform: 'translateX(10px)'
      }
    }
  },
  arrow: {
    marginLeft: '.25rem',
    transition: 'transform .25s ease-in-out',
    display: 'inline-block'
  },
  content: {}
}));

const CardContent = _ref => {
  var _cta$image;

  let {
    cta,
    close,
    handleNavigate
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: classes.card,
    onClick: close
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_gatsbyPluginImage.GatsbyImage, {
    image: (_cta$image = cta.image) === null || _cta$image === void 0 ? void 0 : _cta$image.asset.gatsbyImageData,
    imgStyle: {
      objectFit: 'contain'
    },
    style: {
      borderRadius: '8px 0 0 8px'
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6,
    style: {
      borderLeft: '4px solid #002D5C',
      padding: '0 1rem'
    },
    container: true,
    onClick: close,
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_reactPortableText.default, {
    content: cta._rawContent,
    serializers: {
      normal: _ref2 => {
        let {
          children
        } = _ref2;
        return /*#__PURE__*/_react.default.createElement(_core.Typography, {
          className: classes.content,
          onClick: close,
          variant: "body2",
          style: {
            marginTop: '1rem',
            marginBottom: '1rem',
            textDecoration: 'none',
            userSelect: 'none'
          }
        }, children);
      },
      h4: _ref3 => {
        let {
          children
        } = _ref3;
        return /*#__PURE__*/_react.default.createElement(_core.Typography, {
          className: classes.content,
          onClick: close,
          variant: "h4",
          style: {
            textDecoration: 'none',
            userSelect: 'none',
            fontSize: '1.25rem',
            color: '#002D5C',
            fontWeight: 600
          }
        }, children);
      },
      internalLink: _ref4 => {
        let {
          children,
          internalSlug
        } = _ref4;
        return /*#__PURE__*/_react.default.createElement("span", {
          onClick: () => handleNavigate(internalSlug),
          style: {
            textDecoration: 'none',
            color: '#002D5C'
          }
        }, children, " ", /*#__PURE__*/_react.default.createElement("span", {
          className: classes.arrow
        }, "\u2192"));
      },
      link: _ref5 => {
        let {
          children,
          href
        } = _ref5;
        return /*#__PURE__*/_react.default.createElement("a", {
          href: href,
          target: "_blank",
          rel: "noopener noreferrer",
          style: {
            textDecoration: 'none',
            color: '#002D5C'
          }
        }, children, " ", /*#__PURE__*/_react.default.createElement("span", {
          className: classes.arrow
        }, "\u2192"));
      }
    }
  })));
};

const NavCtaCallout = _ref6 => {
  let {
    calloutCtas,
    resourceBar
  } = _ref6;
  const popupState = (0, _hooks.usePopupState)({
    variant: 'popover',
    popupId: 'demoMenu'
  });
  const {
    close
  } = popupState;

  const handleNavigate = link => {
    (0, _gatsby.navigate)("/".concat(link));
    close();
  };

  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    style: {
      margin: '1rem 0'
    },
    container: true,
    onClick: close,
    justifyContent: "space-between",
    alignItems: "center",
    spacing: 4
  }, calloutCtas.map((cta, index) => cta.internalLink ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: calloutCtas.length === 1 ? 12 : 6,
    key: index,
    onClick: close
  }, /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
    to: cta.link,
    style: {
      textDecoration: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement(CardContent, {
    cta: cta,
    close: close,
    handleNavigate: handleNavigate
  }))) : /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: calloutCtas.length === 1 ? 12 : 6,
    key: index,
    onClick: close
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: cta.link,
    target: "_blank",
    rel: "noreferrer",
    style: {
      textDecoration: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement(CardContent, {
    cta: cta,
    close: close,
    handleNavigate: handleNavigate
  })))));
};

exports.NavCtaCallout = NavCtaCallout;